<template>
  <div class="curl-notes modal-container">
    <div class="modal-wrapper">
      <div class="modal-content modal-dialog-scrollable">
        <div class="modal-header row">
          <h3>{{ title }}</h3>
          <div 
            v-if="existingNote" 
            class="header-info">
            <div class="header-date">
              <p>Created: {{ transformDate(noteData.created_at) }}</p>
              <p>Updated: {{ transformDate(noteData.updated_at) }}</p>
            </div>
            <div 
              class="delete-note-container" 
              @click.prevent="deleteData">
              <remove-svg class="delete-note"/>
            </div>

          </div>
          <div class="header-tags">
            <span 
              v-for="tag in tags"
              :key="tag"
              class="tag">
              {{ tag }}
              <span 
                class="remove-tag" 
                @click="removeTag(tag)">+</span>
            </span>
            <input
              v-if="showTagInput"
              v-model="inputTag"
              type="text"
              placeholder="Add Tag"
              @keyup.enter="addTag">
            <a
              v-if="showTagInput"
              class="add-tag"
              @click.prevent="addTag">Add</a>
            <a
              v-if="!showTagInput"
              @click.prevent="showTagInput = true">Click to add tags</a>
          </div>
        </div>
        <div class="modal-body row">
          <quill-editor 
            ref="myTextEditor"
            v-model="content"
            :options="editorOption"
            @change="onEditorChange($event)"/>
        </div>
        <div class="modal-footer row">
          <button 
            class="save-note" 
            @click.prevent="saveData">{{ saveButtonText }}</button>
        </div>
        <span 
          class="close-modal" 
          @click.prevent="showModal(false)">+</span>

      </div>
    </div>
  </div>
</template>
<script>
import profileMixin from "@/mixins/profileMixin";
import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {mapActions, mapGetters} from "vuex";
import RemoveSvg from "../../SVG/RemoveSvg";

export default {

    components: {
        RemoveSvg,
        quillEditor
    },
    mixins: [profileMixin],

    data: () => ({
        existingNote: false,
        title: 'ADD NOTE',
        saveButtonText: 'Save',
        noteData: {},
        params: {},
        tags: [],
        showTagInput: false,
        inputTag: '',
        body: '',
        content: '<p>Add Your Note</p>',
        editorOption: {
            modules: {
                toolbar: 
                    [['bold', 'italic'], ['link', 'image']]
            },
            readOnly: true,
            theme: 'snow'
        }
    }),

    computed: {
        ...mapGetters(['user']),
    },

    created() {
        this.noteData = this.$store.state.Auth.modal.data;
        if (this.noteData) {
            this.prepareModalForUpdate()
        } else {
            this.noteData = {}
        }
    },

    methods: {
        ...mapActions(['saveNote', 'deleteNote', 'fetchNotes', 'approveInsight']),

        prepareModalForUpdate(){
            this.existingNote = true;
            this.title = 'UPDATE OR REMOVE NOTE';
            this.saveButtonText = 'Update';
            this.tags = this.noteData.tags ? this.noteData.tags : [];
            this.content = this.noteData.body;
            this.body = this.content
        },

        saveData() {
            this.noteData['userId'] = this.user.id;
            this.noteData['noteId'] = this.noteData.id ? this.noteData.id : null;
            this.noteData['tags'] = this.tags.length ? this.tags : null;
            this.noteData['body'] = this.body;

            this.saveNote(this.noteData).then(() => {
                this.showModal(false)
                this.updateNotesData();
                if (this.noteData['title'] === 'Regimen Review') {
                    this.approveInsight(this.noteData)
                }
                if (this.$route.path !== '/curl-notes') {
                    this.$router.push({path: '/curl-notes'})
                }
            });
        },

        deleteData() {
            this.noteData['noteId'] = this.noteData.id ? this.noteData.id : null;
            this.deleteNote(this.noteData).then(() => {
                this.updateNotesData();
                this.showModal(false)
            })
        },

        onEditorChange(event) {
            this.body = event.html
        },

        addTag() {
            let tag = this.inputTag;

            if (this.tags.indexOf(tag) === -1 && this.inputTag !== '') {
                this.tags.push(tag);
                this.showTagInput = false;
            }
        },

        removeTag(tag) {
            this.tags.splice(this.tags.indexOf(tag), 1)
        },

        updateNotesData() {
            this.params['userId'] = this.user.id;
            this.fetchNotes(this.params);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modals/CurlNotesModal/UpdateCurlNote.vue